(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  function initMarquee(container = document) {
    container.querySelectorAll('.marquee').forEach((marquee) => {
      const track = marquee.querySelector('.marquee-track');
      if (!track) return;

      const speed = parseFloat(getComputedStyle(marquee).getPropertyValue('--marquee-speed')) || 80;

      // reset if reinit
      if (track.dataset.originalWidth) return;

      const originalItems = Array.from(track.children);
      if (!originalItems.length) return;

      const originalWidth = Math.ceil(track.scrollWidth);
      track.dataset.originalWidth = originalWidth;

      while (track.scrollWidth < marquee.offsetWidth + originalWidth * 2) {
        originalItems.forEach((item) => {
          track.appendChild(item.cloneNode(true));
        });
      }

      const distance = originalWidth;
      const duration = distance / speed;

      track.style.setProperty('--marquee-distance', `${distance}px`);
      track.style.setProperty('--marquee-duration', `${duration}s`);
    });
  }

  window.addEventListener('DOMContentLoaded', () => initMarquee());
  window.addEventListener('resize', () => initMarquee());  

  document.addEventListener('shopify:section:load', (e) => {
    initMarquee(e.target);
  });

  } catch(e) { console.error(e); }
})();
})();
